import React,{useEffect, useState} from "react";
import { FormattedMessage } from "react-intl";
import { Button } from "@ts-digital/vrc";
import VaporContentSwitcherTab from "../../../vapor/contentSwitcherTab";
import VaporDrawer from "../../../general/vapor/drawer";

import "./style.css";
import ContentWitholding from "./contentWitholding";
import { useDispatch, useSelector } from "react-redux";
import { getWithholdingEditableFields, getWithholdingNonEditableFields, updateWithholding } from "../../../../store/actions/precog/withholding";
import { Spin } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
/**
 * @param {
 * withholding: oggetto ritenute
 * isOnlyWithHolding: identifica il tab ritenute
 * isReadOnly: se true non mostra il bottone salva
 * setWithHoldingDrawer: serve a settare la visibilità del drawer
 * draftId: id del draft utile in tab contabilizza / non contabilizzati
 * totalTaxable:
 */
const WithHoldingDrawerDetail = ({ draftId, isOnlyWithHolding, isReadOnly, setWithHoldingDrawer, setVisibleDrawer, totalTaxable, visibleDrawer, withholding, currentType}) => {

  const dispatch = useDispatch();
  const [drawerContentSwitch,setDrawerContentSwitch] = useState("IRPEF");
  const [modifiedFields, setModifiedFields] = useState({});
  const [nonEditable, setNonEditable] = useState({});
  const [editable, setEditable] = useState({});
  const [isLoadingDrawer, setIsLoadingDrawer] = useState(false);
  const nonEditableFields = useSelector(state => state.precog.withholdingFields?.nonEditableFields);

  /**
   * isOnlyWithHolding distigue i dati del tab ritenuta da quelli da contabilizzare / contabilizzati
   */

  useEffect(() => {    
    
    if (isOnlyWithHolding) {
      // dal dettaglio arriva tutto insieme, distinguo editabili da non editabili
      setNonEditable(withholding);
      // setEditable
      // setNonEditable
    } else {
      setIsLoadingDrawer(true);
      dispatch(getWithholdingEditableFields(draftId,
        withholding.uuid)).then(res => setEditable(res)).then(() => {            
        dispatch(getWithholdingNonEditableFields({...withholding, totalNetAmount: totalTaxable})).then(() =>{
          setIsLoadingDrawer(false);
        });
      });
      
    }
    if (visibleDrawer) {
      // blocco lo scroll del body
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [withholding]);

  useEffect(() => {
    if (nonEditableFields) {
      setNonEditable({ ...nonEditableFields, totalNetAmount: totalTaxable, withholdingRate: withholding.withholdingRate });
    }
  }, [nonEditableFields]);

  useEffect(() => {
    if (currentType) {
      setDrawerContentSwitch(currentType);
    }
  }, [currentType]);

  useEffect(() => {
    if (modifiedFields) return; 
    if (modifiedFields && !isOnlyWithHolding) {
      dispatch(updateWithholding(
        draftId,
        withholding.uuid,
        modifiedFields
      )).then(() => {        
        dispatch(getWithholdingNonEditableFields({ ...editable, totalNetAmount: totalTaxable }));
      });
    } else {
      // TODO salvataggio isOnlyWithHolding
    }
  }, [modifiedFields]);

  const onSave = () => {
    setWithHoldingDrawer(null);
    setVisibleDrawer(false);
  };

  const buttonsDrawer = [<Button key={0} kind="secondary" onClick={() => {setWithHoldingDrawer(null); setVisibleDrawer(false);}}>Chiudi</Button>];
  if (isReadOnly) {
    buttonsDrawer.push(<Button key={1} kind="primary" onClick={() => onSave()}>Salva</Button>);
  }

  return (
    <VaporDrawer
      visible={visibleDrawer}
      width={700}
      buttons={buttonsDrawer}
      onClose={() => {setWithHoldingDrawer(null); setVisibleDrawer(false);}}
      title={<FormattedMessage id="preCog.withholdingsTab.drawer.masterTitle" />}
      subtitle={withholding?.title}
      titleAlign="center"
    >
      {
        isLoadingDrawer ? 
          <div style={{display: "flex", alignItems: "center", justifyContent: "center", height: "100%"}}>
            <Spin
              indicator={<FontAwesomeIcon icon={["far", "circle-notch"]} spin />}
              size={"large"}
              tip={""}
              style={{ fontSize: "25px" }}
            />
          </div>
          :
          <div className="precog-withholding-drawer-root">
            <div className="drawer-header">
              <VaporContentSwitcherTab
                className="lightColor"
                selected={drawerContentSwitch}
                /* itemsWidth={140}*/
                onChange={val => setDrawerContentSwitch(val)}
                items={Object.keys(withholding.types).length > 1 ? [
                  { value: "IRPEF", label: "Gestione ritenuta" },
                  { value: "INPS", label: "Gestione ritenute previdenziali" }
                ] : Object.keys(withholding.types)[0] === "INPS" ? [{ value: "INPS", label: "Gestione ritenute previdenziali" }] : [{ value: "IRPEF", label: "Gestione ritenuta" }]}
              />
            </div>
            <div className="precog-withholding-drawer-content-items">

              <ContentWitholding setEditable={setEditable} draftId={draftId} withholdingDrawer={withholding} setWithHoldingDrawer={setWithHoldingDrawer} drawerContentSwitch={drawerContentSwitch} isReadOnly={isReadOnly} editableDataSet={editable}
                modifiedFields={modifiedFields} withholdingUuId={withholding?.uuid}
                nonEditableDataSet={nonEditable} setModifiedFields={setModifiedFields}
                totalTaxable={totalTaxable}
              />

            </div>
          </div>
      }      
    </VaporDrawer>
  );
};

export default WithHoldingDrawerDetail;